module.exports = (string) => {
  let asciiVal = 0;
  [...string].forEach((char) => (asciiVal += char.charCodeAt(0)));
  return asciiVal;
};
